import { tns } from 'tiny-slider/src/tiny-slider';
import whenDomReady from 'when-dom-ready';

function initialise() {
  const Carousel = document.querySelector('.instrument-guide__tabs');

  // eslint-disable-next-line no-unused-vars
  const slider = tns({
    container: Carousel,
    loop: false,
    center: false,
    mouseDrag: true,
    items: 1,
    nav: false,
    controls: false,
    responsive: {
      480: {
        items: 2,
        center: false,
      },
      991: {
        mouseDrag: true,
        items: 4,
        center: false,
      },
    },
  });
}

whenDomReady().then(initialise);
